<template>
  <div class="split">
    <aside class="cat-panel">
      <div class="cat-hd">
        <span>物料分类</span>
        <div v-if="isAuth('base:materialClassify:save')" class="cat-hd-actions">
          <el-button type="text" icon="el-icon-plus" title="新增分类" @click="openClassify()" />
        </div>
      </div>
      <div class="cat-all" :class="{ active: !currentClassify }" @click="selectAllClassify">全部分类</div>
      <el-tree
        ref="catTree"
        class="cat-tree"
        :data="tree"
        node-key="classifyId"
        :props="{ label: 'displayName', children: 'children' }"
        highlight-current
        default-expand-all
        :expand-on-click-node="false"
        @node-click="pickClassify"
      >
        <span slot-scope="{ data }" class="cat-node">
          <span class="cat-label" :title="data.displayName">{{ data.displayName }}</span>
          <span class="cat-ops" @click.stop>
            <i v-if="isAuth('base:materialClassify:save')" class="el-icon-plus" title="新增子分类" @click="openClassify(null, data.classifyId)" />
            <i v-if="isAuth('base:materialClassify:update')" class="el-icon-edit" title="编辑" @click="openClassify(data)" />
            <i v-if="isAuth('base:materialClassify:delete')" class="el-icon-delete" title="删除" @click="removeClassify(data)" />
          </span>
        </span>
      </el-tree>
    </aside>
    <div class="main">
      <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
        <el-form-item label="物料编码"><el-input v-model="query.code" size="small" clearable style="width:150px" /></el-form-item>
        <el-form-item label="物料名称"><el-input v-model="query.partnerName" size="small" clearable style="width:150px" /></el-form-item>
        <el-form-item><el-button type="primary" size="small" @click="search">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" @click="queryVisible = true">更多查询</el-button></el-form-item>
        <el-form-item><el-button size="small" @click="resetQuery">重置</el-button></el-form-item>
        <el-form-item v-if="moreQuerySummary"><span class="query-summary">{{ moreQuerySummary }}</span></el-form-item>
        <el-form-item v-if="isAuth('base:material:save')"><el-button type="primary" size="small" @click="open()">新增</el-button></el-form-item>
      </el-form>
      <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle" @row-dblclick="row => open(row.materialId, true)">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="materialCode" label="物料编码" width="130" show-overflow-tooltip>
          <template slot-scope="scope"><span class="code-link" @click="open(scope.row.materialId, true)">{{ scope.row.materialCode }}</span></template>
        </el-table-column>
        <el-table-column prop="materialName" label="物料名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="specs" label="规格型号" min-width="120" show-overflow-tooltip />
        <el-table-column prop="classifyName" label="物料分类" width="120" />
        <el-table-column label="计划策略" width="90" align="center"><template slot-scope="scope">{{ planLabel(scope.row.planStrategy) }}</template></el-table-column>
        <el-table-column label="供给方式" width="80" align="center"><template slot-scope="scope">{{ supplyLabel(scope.row.supplyType) }}</template></el-table-column>
        <el-table-column prop="unitName" label="库存单位" width="90" />
        <el-table-column label="默认仓库" width="160" show-overflow-tooltip><template slot-scope="scope">{{ warehouseText(scope.row) }}</template></el-table-column>
        <el-table-column label="启用状态" width="90" align="center">
          <template slot-scope="scope"><el-tag :type="scope.row.isenable === '1' ? 'danger' : 'success'" size="small">{{ scope.row.isenable === '1' ? '禁用' : '启用' }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="updateByName" label="修改人" width="90" />
        <el-table-column label="修改日期" width="110" align="right"><template slot-scope="scope">{{ String(scope.row.updateDate || '').substr(0, 10) }}</template></el-table-column>
      </el-table>
      <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
        layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; search() }" @current-change="p => { pageIndex = p; load() }" />
    </div>

    <el-dialog title="更多查询条件" :visible.sync="queryVisible" width="480px" append-to-body>
      <el-form label-width="100px">
        <el-form-item label="规格型号"><el-input v-model="query.specs" size="small" clearable /></el-form-item>
        <el-form-item label="计划策略">
          <el-select v-model="query.planStrategy" size="small" clearable placeholder="全部" style="width:100%">
            <el-option label="按单" value="MTO" /><el-option label="备库" value="MTS" /><el-option label="混合" value="MIX" />
          </el-select>
        </el-form-item>
        <el-form-item label="供给方式">
          <el-select v-model="query.supplyType" size="small" clearable placeholder="全部" style="width:100%">
            <el-option label="自制" value="make" /><el-option label="外购" value="buy" /><el-option label="委外" value="subcontract" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer"><el-button size="small" @click="queryVisible = false">取消</el-button><el-button type="primary" size="small" @click="queryVisible = false; search()">确定</el-button></span>
    </el-dialog>

    <el-dialog :visible.sync="visible" width="80%" top="4vh" :close-on-click-modal="false">
      <template slot="title">
        <div class="mat-dialog-title">
          <span>{{ dialogTitle }}</span>
          <span v-if="readonly && form.materialId" class="mat-dialog-actions">
            <el-button v-if="isAuth('base:material:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('base:material:save') || isAuth('base:material:copyTemplate')" type="primary" size="small" @click="copyFromView(false)">快速复制</el-button>
            <el-button v-if="isAuth('base:material:save') || isAuth('base:material:copyTemplate')" type="primary" size="small" @click="copyFromView(true)">高级复制</el-button>
            <el-button v-if="isAuth('base:material:update') || isAuth('base:material:copyData')" type="primary" size="small" @click="openCopyData">复制数据</el-button>
            <el-button v-if="isAuth('base:material:delete')" type="primary" size="small" @click="remove">删除</el-button>
          </span>
        </div>
      </template>
      <el-form label-width="100px" :disabled="readonly">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="物料编码" required><el-input v-model="form.materialCode" placeholder="物料编码" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称" required><el-input v-model="form.materialName" placeholder="物料名称" /></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="客户编码"><el-input v-model="form.customerCode" placeholder="客户编码" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号"><el-input v-model="form.specs" placeholder="规格型号" /></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="物料分类" required>
              <el-select v-model="form.classifyId" filterable style="width:100%">
                <el-option v-for="item in flat" :key="item.classifyId" :label="item.classifyName" :value="item.classifyId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认仓库">
              <warehouse-location-select v-model="form.wareHouseId" :disabled="readonly" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="生产工艺">
              <el-select v-model="form.routingId" disabled style="width:100%" placeholder="请在工艺发布中绑定">
                <el-option v-for="item in routings" :key="item.routingId" :label="item.routingName" :value="item.routingId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安全库存"><el-input v-model="form.safetyStock" placeholder="库存预警用" /></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="计划策略">
              <el-select v-model="form.planStrategy" style="width:100%">
                <el-option label="按单 MTO" value="MTO" /><el-option label="备库 MTS" value="MTS" /><el-option label="混合 MIX" value="MIX" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供给方式">
              <el-select v-model="form.supplyType" style="width:100%">
                <el-option label="自制" value="make" /><el-option label="外购" value="buy" /><el-option label="委外" value="subcontract" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="来料检验">
              <el-select v-model="form.needIqc" style="width:100%">
                <el-option label="免检" value="0" /><el-option label="须检" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="提前期(天)">
              <el-input-number v-model="form.leadTimeDays" :min="0" :precision="0" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计划安全库存"><el-input v-model="form.safetyQty" placeholder="MRP用，空则取安全库存" /></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="最小订货量"><el-input v-model="form.minOrderQty" placeholder="MOQ，0表示不限制" /></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="条码管理">
              <el-select v-model="form.barcodeManageMode" style="width:100%">
                <el-option label="不启用" value="none" /><el-option label="条码(按数量)" value="barcode" /><el-option label="序列号(一物一码)" value="serial" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用状态">
              <el-radio-group v-model="form.isenable"><el-radio label="0">启用</el-radio><el-radio label="1">禁用</el-radio></el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="3" /></el-form-item>
      </el-form>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="单位换算" name="unit">
          <el-form :inline="true" label-width="90px" :disabled="readonly">
            <el-form-item label="库存单位" required>
              <el-select v-model="form.unit" size="small" filterable clearable style="width:160px" @change="onStockUnit">
                <el-option v-for="item in unitOptions" :key="item.id" :label="item.dictLabel" :value="String(item.id)" />
              </el-select>
            </el-form-item>
            <el-form-item label="采购单位">
              <el-select v-model="form.purchaseUnit" size="small" filterable clearable style="width:160px">
                <el-option v-for="item in unitOptions" :key="'p' + item.id" :label="item.dictLabel" :value="String(item.id)" />
              </el-select>
            </el-form-item>
            <el-form-item label="销售单位">
              <el-select v-model="form.salesUnit" size="small" filterable clearable style="width:160px">
                <el-option v-for="item in unitOptions" :key="'s' + item.id" :label="item.dictLabel" :value="String(item.id)" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button v-if="!readonly" size="mini" type="primary" @click="addUnit">新增换算行</el-button>
          <el-table :data="units" border size="mini" :header-cell-style="headStyle" style="margin-top:8px">
            <el-table-column label="库存单位" min-width="130"><template slot-scope="scope"><el-input :value="unitName(scope.row.unit)" disabled size="mini" /></template></el-table-column>
            <el-table-column label="换算单位" min-width="130">
              <template slot-scope="scope">
                <el-select v-model="scope.row.convertUnit" size="mini" filterable clearable :disabled="readonly || scope.$index === 0">
                  <el-option v-for="item in unitOptions" :key="item.id" :label="item.dictLabel" :value="String(item.id)" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="换算数量" width="140"><template slot-scope="scope"><el-input-number v-model="scope.row.convertInventory" size="mini" :min="0.000001" :precision="6" :disabled="readonly || scope.$index === 0" /></template></el-table-column>
            <el-table-column label="换算方向" width="130">
              <template slot-scope="scope">
                <el-select v-model="scope.row.direction" size="mini" :disabled="readonly || scope.$index === 0">
                  <el-option label="数量在右" value="0" /><el-option label="数量在左" value="1" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="排序" width="110"><template slot-scope="scope"><el-input-number v-model="scope.row.sort" size="mini" :min="0" :precision="0" :disabled="readonly" /></template></el-table-column>
            <el-table-column label="备注" min-width="120"><template slot-scope="scope"><el-input v-model="scope.row.remark" size="mini" :disabled="readonly" /></template></el-table-column>
            <el-table-column v-if="!readonly" label="操作" width="70"><template slot-scope="scope"><el-button type="text" size="mini" :disabled="scope.$index === 0" @click="units.splice(scope.$index, 1)">删除</el-button></template></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="条码" name="barcode">
          <el-button v-if="!readonly" size="mini" type="primary" @click="barcodes.push({ barcode: '', barcodeType: 'OTHER', isDefault: '0', remark: '' })">新增条码</el-button>
          <el-table :data="barcodes" border size="mini" :header-cell-style="headStyle" style="margin-top:8px">
            <el-table-column label="条码" min-width="180"><template slot-scope="scope"><el-input v-model="scope.row.barcode" size="mini" :disabled="readonly" /></template></el-table-column>
            <el-table-column label="类型" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.barcodeType" size="mini" :disabled="readonly"><el-option label="EAN" value="EAN" /><el-option label="UPC" value="UPC" /><el-option label="其他" value="OTHER" /></el-select>
              </template>
            </el-table-column>
            <el-table-column label="默认" width="70" align="center"><template slot-scope="scope"><el-checkbox v-model="scope.row.isDefault" true-label="1" false-label="0" :disabled="readonly" /></template></el-table-column>
            <el-table-column v-if="!readonly" label="操作" width="70"><template slot-scope="scope"><el-button type="text" size="mini" @click="barcodes.splice(scope.$index, 1)">删除</el-button></template></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="配置" name="config">
          <el-button v-if="!readonly" size="mini" type="primary" @click="addAttribute">新增配置项</el-button>
          <el-table :data="attributes" border size="mini" :header-cell-style="headStyle" style="margin-top:8px">
            <el-table-column label="配置项" min-width="140"><template slot-scope="scope"><el-input v-model="scope.row.attributeName" size="mini" :disabled="readonly" /></template></el-table-column>
            <el-table-column label="属性值维护" min-width="360">
              <template slot-scope="scope">
                <el-radio-group :value="defaultIndex(scope.row)" :disabled="readonly" @input="index => setDefault(scope.row, index)">
                  <div v-for="(item, index) in scope.row.valueList" :key="index" class="attr-value-row">
                    <el-input v-model="item.attributeValue" size="mini" placeholder="属性值" style="width:42%" :disabled="readonly" />
                    <el-input-number v-model="item.sort" size="mini" :min="0" :precision="0" style="width:90px;margin-left:6px" :disabled="readonly" />
                    <el-radio :label="index" style="margin-left:8px">默认</el-radio>
                    <el-button v-if="!readonly" type="text" size="mini" @click="removeValue(scope.row, index)">删除</el-button>
                  </div>
                </el-radio-group>
                <el-button v-if="!readonly" type="text" size="mini" @click="scope.row.valueList.push({ attributeValue: '', sort: scope.row.valueList.length, isdefault: '0' })">新增属性值</el-button>
              </template>
            </el-table-column>
            <el-table-column label="排序" width="110"><template slot-scope="scope"><el-input-number v-model="scope.row.sort" size="mini" :min="0" :precision="0" :disabled="readonly" /></template></el-table-column>
            <el-table-column label="备注" min-width="120"><template slot-scope="scope"><el-input v-model="scope.row.remark" size="mini" :disabled="readonly" /></template></el-table-column>
            <el-table-column v-if="!readonly" label="操作" width="70"><template slot-scope="scope"><el-button type="text" size="mini" @click="attributes.splice(scope.$index, 1)">删除</el-button></template></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="销售" name="sale">
          <el-form :inline="true" label-width="100px" :disabled="readonly">
            <el-form-item label="销售含税价"><el-input v-model="form.price" size="small" style="width:140px" /></el-form-item>
            <el-form-item label="销售未税价"><el-input v-model="form.notaxPrice" size="small" style="width:140px" /></el-form-item>
            <el-form-item label="销售税点"><el-input v-model="form.tax" size="small" style="width:140px" /></el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="采购" name="purchase">
          <el-form :inline="true" label-width="100px" :disabled="readonly">
            <el-form-item label="采购含税价"><el-input v-model="form.poPrice" size="small" style="width:140px" /></el-form-item>
            <el-form-item label="采购未税价"><el-input v-model="form.poNotaxPrice" size="small" style="width:140px" /></el-form-item>
            <el-form-item label="采购税点"><el-input v-model="form.poTax" size="small" style="width:140px" /></el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="替代料" name="replace">
          <el-button v-if="!readonly" size="mini" type="primary" @click="replaces.push({ replaceMaterialId: '', replaceRatio: 1, sort: replaces.length + 1, remark: '' })">新增替代料</el-button>
          <el-table :data="replaces" border size="mini" :header-cell-style="headStyle" style="margin-top:8px">
            <el-table-column label="替代料" min-width="220">
              <template slot-scope="scope">
                <el-select v-model="scope.row.replaceMaterialId" size="mini" filterable clearable style="width:100%" :disabled="readonly">
                  <el-option v-for="item in materialOptions" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="替代比例" width="130"><template slot-scope="scope"><el-input-number v-model="scope.row.replaceRatio" size="mini" :min="0.01" :step="0.01" :precision="2" :disabled="readonly" /></template></el-table-column>
            <el-table-column label="排序" width="110"><template slot-scope="scope"><el-input-number v-model="scope.row.sort" size="mini" :min="0" :precision="0" :disabled="readonly" /></template></el-table-column>
            <el-table-column label="备注" min-width="140"><template slot-scope="scope"><el-input v-model="scope.row.remark" size="mini" :disabled="readonly" /></template></el-table-column>
            <el-table-column v-if="!readonly" label="操作" width="70"><template slot-scope="scope"><el-button type="text" size="mini" @click="replaces.splice(scope.$index, 1)">删除</el-button></template></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-form-item v-if="copyMode && showCopyOptions && !readonly" label="复制附属数据">
        <el-checkbox v-model="copyOption.copyUnit">单位换算</el-checkbox>
        <el-checkbox v-model="copyOption.copyAttribute">物料属性</el-checkbox>
        <el-checkbox v-model="copyOption.copyBom">物料清单(BOM)</el-checkbox>
      </el-form-item>
      <el-form-item v-if="copyMode && showCopyOptions && copyOption.copyBom && !readonly" label="BOM选项">
        <el-checkbox v-model="copyOption.onlyEnabledBom">仅复制启用版本</el-checkbox>
      </el-form-item>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="复制数据" :visible.sync="copyDataVisible" width="520px" :close-on-click-modal="false" append-to-body>
      <el-form label-width="110px">
        <el-form-item label="目标物料"><el-input :value="copyData.targetText" disabled /></el-form-item>
        <el-form-item label="源物料" required>
          <el-select v-model="copyData.sourceMaterialId" filterable clearable style="width:100%" placeholder="请选择源物料" @change="loadSourceBomCount">
            <el-option v-for="item in copySourceOptions" :key="item.materialId" :value="item.materialId" :label="item.materialCode + ' / ' + item.materialName" />
          </el-select>
        </el-form-item>
        <el-form-item label="复制内容">
          <el-checkbox v-model="copyData.copyUnit">单位换算</el-checkbox>
          <el-checkbox v-model="copyData.copyAttribute">物料属性</el-checkbox>
          <el-checkbox v-model="copyData.copyBom">物料清单(BOM)</el-checkbox>
        </el-form-item>
        <el-form-item v-if="copyData.copyBom" label="BOM选项">
          <el-checkbox v-model="copyData.onlyEnabledBom" @change="loadSourceBomCount">仅复制启用版本</el-checkbox>
          <div class="copy-tip">源BOM可复制条数：{{ copyData.sourceBomCount }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="copyDataVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCopyData">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="classify.classifyId ? '编辑分类' : '新增分类'" :visible.sync="classifyVisible" width="440px">
      <el-form label-width="90px">
        <el-form-item label="分类编码" required><el-input v-model="classify.classifyCode" maxlength="32" placeholder="请输入分类编码" /></el-form-item>
        <el-form-item label="分类名称" required><el-input v-model="classify.classifyName" maxlength="64" placeholder="请输入分类名称" /></el-form-item>
        <el-form-item label="上级分类">
          <el-cascader
            v-model="classify.parentId"
            :options="parentClassifyOptions"
            :props="{ value: 'classifyId', label: 'classifyName', children: 'children', checkStrictly: true, emitPath: false }"
            clearable
            filterable
            placeholder="不选则为顶级"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="classify.sort" :min="0" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="classifyVisible = false">取消</el-button>
        <el-button type="primary" @click="saveClassify">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'

export default {
  name: 'Material',
  components: { WarehouseLocationSelect },
  data() {
    return {
      query: { code: '', partnerName: '', specs: '', planStrategy: '', supplyType: '' }, queryVisible: false,
      list: [], tree: [], flat: [], routings: [], unitOptions: [], materialOptions: [],
      pageIndex: 1, pageSize: 20, total: 0, loading: false,
      visible: false, readonly: false, activeTab: 'unit', form: {}, units: [], barcodes: [], attributes: [], replaces: [],
      copyMode: false, showCopyOptions: false, copySourceId: '',
      copyOption: { copyUnit: true, copyAttribute: true, copyBom: true, onlyEnabledBom: true },
      copyDataVisible: false, copySourceOptions: [],
      copyData: { targetMaterialId: '', targetText: '', sourceMaterialId: '', copyUnit: true, copyAttribute: true, copyBom: true, onlyEnabledBom: true, sourceBomCount: 0, targetBomCount: 0 },
      classifyVisible: false, classify: {}, currentClassify: '', permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  created() { this.loadPerms(); this.loadClassifies(); this.load() },
  computed: {
    parentClassifyOptions() {
      const exclude = this.classify && this.classify.classifyId
      const clone = nodes => (nodes || []).filter(node => node.classifyId !== exclude).map(node => {
        const children = clone(node.children)
        return children.length ? { ...node, children } : { ...node, children: undefined }
      })
      return clone(this.tree)
    },
    dialogTitle() {
      if (this.readonly) return '详情'
      return this.form.materialId ? '修改' : '新增'
    },
    moreQuerySummary() {
      const parts = []
      if (this.query.specs) parts.push('规格型号：' + this.query.specs)
      if (this.query.planStrategy) parts.push('计划策略：' + this.planLabel(this.query.planStrategy))
      if (this.query.supplyType) parts.push('供给方式：' + this.supplyLabel(this.query.supplyType))
      if (!parts.length) return ''
      return parts.length === 1 ? parts[0] : ('更多条件 ' + parts.length + ' 项')
    }
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    loadClassifies() {
      request.post('/base/materialClassify/list', {}).then(res => {
        const rows = res.data || []
        this.flat = rows
        const map = {}
        rows.forEach(row => {
          map[row.classifyId] = {
            ...row,
            displayName: ((row.classifyCode || '') + ' ' + (row.classifyName || '')).trim(),
            children: []
          }
        })
        const roots = []
        rows.forEach(row => {
          const node = map[row.classifyId]
          if (row.parentId && map[row.parentId]) map[row.parentId].children.push(node)
          else roots.push(node)
        })
        this.tree = roots
      }).catch(() => {})
    },
    pickClassify(node) {
      this.currentClassify = node.classifyId
      this.search()
    },
    selectAllClassify() {
      this.currentClassify = ''
      if (this.$refs.catTree) this.$refs.catTree.setCurrentKey(null)
      this.search()
    },
    search() { this.pageIndex = 1; this.load() },
    resetQuery() {
      this.query = { code: '', partnerName: '', specs: '', planStrategy: '', supplyType: '' }
      this.currentClassify = ''
      if (this.$refs.catTree) this.$refs.catTree.setCurrentKey(null)
      this.search()
    },
    planLabel(v) { return { MTO: '按单', MTS: '备库', MIX: '混合' }[v] || v || '—' },
    supplyLabel(v) { return { make: '自制', buy: '外购', subcontract: '委外' }[v] || v || '—' },
    warehouseText(row) {
      if (row.wareHouseName) return row.wareHouseName
      if (!row.wareHouseId) return '—'
      return String(row.wareHouseId).indexOf('/') > -1 ? String(row.wareHouseId).replace(/\//g, ' / ') : row.wareHouseId
    },
    load() {
      this.loading = true
      request.post('/base/material/page', {
        currentPage: this.pageIndex, pageSize: this.pageSize, code: this.query.code, partnerName: this.query.partnerName,
        classifyId: this.currentClassify, specs: this.query.specs, planStrategy: this.query.planStrategy, supplyType: this.query.supplyType
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    loadOptions() {
      request.post('/base/routing/list', { currentPage: 1, pageSize: 500 }).then(res => { this.routings = (res.data && res.data.list) || [] }).catch(() => {})
      request.get('/sys/dicts', { params: { dictType: 'MATERIAL_UNIT' } }).then(res => { this.unitOptions = res.data || [] }).catch(() => {})
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => { this.materialOptions = (res.data && res.data.list) || [] }).catch(() => {})
    },
    unitName(id) {
      const hit = this.unitOptions.find(item => String(item.id) === String(id))
      return hit ? hit.dictLabel : (id || '')
    },
    ensureUnits() {
      const stock = this.form.unit || ''
      if (!this.units.length) {
        this.units = [{ unit: stock, convertUnit: stock, convertInventory: 1, direction: '0', isMain: '1', sort: 0, remark: '' }]
      }
      this.units.forEach(row => { row.unit = stock })
      this.units[0].convertUnit = stock
      this.units[0].convertInventory = 1
      this.units[0].direction = '0'
      this.units[0].isMain = '1'
      this.units[0].sort = 0
    },
    onStockUnit(val) {
      this.form.purchaseUnit = val || ''
      this.form.salesUnit = val || ''
      this.ensureUnits()
    },
    addUnit() {
      this.units.push({ unit: this.form.unit || '', convertUnit: '', convertInventory: 1, direction: '0', isMain: '0', sort: this.units.length, remark: '' })
      this.ensureUnits()
    },
    addAttribute() {
      this.attributes.push({ attributeName: '', sort: this.attributes.length + 1, remark: '', valueList: [{ attributeValue: '', sort: 0, isdefault: '1' }] })
    },
    defaultIndex(row) {
      return (row.valueList || []).findIndex(item => item.isdefault === '1')
    },
    setDefault(row, index) {
      row.valueList.forEach((item, i) => { item.isdefault = i === index ? '1' : '0' })
    },
    removeValue(row, index) {
      if (row.valueList.length <= 1) { this.$message.warning('每个配置项至少保留一个属性值'); return }
      const removed = row.valueList.splice(index, 1)[0]
      if (removed && removed.isdefault === '1') row.valueList[0].isdefault = '1'
    },
    fillChildren(data) {
      this.units = (data.units || []).map(item => ({ ...item, direction: item.direction || '0', isMain: item.isMain || '0', remark: item.remark || '' }))
      this.barcodes = (data.materialBarcodes || []).map(item => ({ barcode: item.barcode, barcodeType: item.barcodeType || 'OTHER', isDefault: item.isDefault || '0', remark: item.remark || '' }))
      this.attributes = (data.attributes || []).map(item => ({
        attributeName: item.attributeName || '', sort: item.sort || 0, remark: item.remark || '',
        valueList: (item.valueList && item.valueList.length ? item.valueList : [{ attributeValue: '', sort: 0, isdefault: '1' }]).map(v => ({
          attributeValue: v.attributeValue || '', sort: v.sort || 0, isdefault: v.isdefault || '0'
        }))
      }))
      this.replaces = (data.replaces || []).map(item => ({ replaceMaterialId: item.replaceMaterialId, replaceRatio: item.replaceRatio != null ? Number(item.replaceRatio) : 1, sort: item.sort || 0, remark: item.remark || '' }))
      if (!this.units.length) this.ensureUnits()
    },
    open(id, view) {
      this.loadOptions()
      this.activeTab = 'unit'
      this.readonly = !!(view && id)
      this.copyMode = false
      this.showCopyOptions = false
      this.copySourceId = ''
      this.form = {
        isenable: '0', planStrategy: 'MIX', supplyType: 'make', needIqc: '0', barcodeManageMode: 'none', leadTimeDays: 0,
        classifyId: this.currentClassify || ''
      }
      this.units = []
      this.barcodes = []
      this.attributes = []
      this.replaces = []
      this.ensureUnits()
      this.visible = true
      if (id) request.get('/base/material/info/' + id).then(res => {
        const row = res.data || {}
        row.leadTimeDays = row.leadTimeDays == null || row.leadTimeDays === '' ? 0 : Number(row.leadTimeDays)
        this.form = row
        this.fillChildren(this.form)
      }).catch(() => {})
    },
    save() {
      if (!this.form.unit) { this.$message.error('请选择库存单位'); this.activeTab = 'unit'; return }
      this.ensureUnits()
      const keepUnit = !this.copyMode || !this.showCopyOptions || this.copyOption.copyUnit
      const keepAttribute = !this.copyMode || !this.showCopyOptions || this.copyOption.copyAttribute
      const payload = {
        ...this.form,
        units: keepUnit ? this.units : [],
        materialBarcodes: this.barcodes,
        attributes: keepAttribute ? this.attributes : [],
        replaces: this.replaces
      }
      const copyBom = this.copyMode && this.showCopyOptions && this.copyOption.copyBom
      request.post('/base/material/' + (this.form.materialId ? 'update' : 'save'), payload).then(res => {
        const savedId = (res.data && res.data.materialId) || this.form.materialId
        const finish = extra => {
          const bomRange = copyBom ? (this.copyOption.onlyEnabledBom ? '（仅启用版本）' : '（全部版本）') : ''
          const summary = extra ? `；附属复制：单位换算${extra.unitCount || 0}条，物料属性${extra.attributeCount || 0}条，BOM${extra.bomCount || 0}条${bomRange}` : ''
          this.$message.success('操作成功' + summary)
          this.visible = false
          this.load()
        }
        if (!copyBom || !savedId || !this.copySourceId) { finish(); return }
        request.post('/base/material/copyData', {
          targetMaterialId: savedId,
          sourceMaterialId: this.copySourceId,
          copyUnit: '0',
          copyAttribute: '0',
          copyBom: '1',
          onlyEnabledBom: this.copyOption.onlyEnabledBom ? '1' : '0'
        }).then(copyRes => finish(copyRes.data || {})).catch(() => {})
      }).catch(() => {})
    },
    copyFromView(advanced) {
      const id = this.form.materialId
      if (!id) return
      request.get('/base/material/copyTemplate/' + id).then(res => {
        const data = res.data || {}
        this.readonly = false
        this.copyMode = true
        this.showCopyOptions = !!advanced
        this.copySourceId = id
        this.copyOption = { copyUnit: !!advanced, copyAttribute: !!advanced, copyBom: !!advanced, onlyEnabledBom: !!advanced }
        this.form = { ...data, materialId: '', materialCode: '', materialName: '' }
        this.fillChildren(data)
        if (!advanced) {
          this.attributes = []
          this.barcodes = []
          this.replaces = []
        } else {
          this.barcodes = []
          this.replaces = []
        }
        this.$message.success(advanced ? '已生成高级复制，请修改编码后保存' : '已生成复制模板，请修改编码后保存')
      }).catch(() => {})
    },
    openCopyData() {
      this.copyData = {
        targetMaterialId: this.form.materialId,
        targetText: (this.form.materialCode || '') + ' / ' + (this.form.materialName || ''),
        sourceMaterialId: '',
        copyUnit: true,
        copyAttribute: true,
        copyBom: true,
        onlyEnabledBom: true,
        sourceBomCount: 0,
        targetBomCount: 0
      }
      request.post('/base/material/page', { currentPage: 1, pageSize: 1000 }).then(res => {
        const list = (res.data && res.data.list) || []
        this.copySourceOptions = list.filter(item => item.materialId !== this.form.materialId)
      }).catch(() => {})
      request.get('/base/materialBom/list', { params: { materialId: this.form.materialId } }).then(res => {
        this.copyData.targetBomCount = (res.data || []).length
      }).catch(() => {})
      this.copyDataVisible = true
    },
    loadSourceBomCount() {
      if (!this.copyData.sourceMaterialId || !this.copyData.copyBom) { this.copyData.sourceBomCount = 0; return }
      request.get('/base/materialBom/list', { params: { materialId: this.copyData.sourceMaterialId } }).then(res => {
        const rows = res.data || []
        this.copyData.sourceBomCount = this.copyData.onlyEnabledBom ? rows.filter(item => String(item.enabled) === '1').length : rows.length
      }).catch(() => { this.copyData.sourceBomCount = 0 })
    },
    submitCopyData() {
      if (!this.copyData.copyUnit && !this.copyData.copyAttribute && !this.copyData.copyBom) {
        this.$message.error('至少勾选一项复制内容'); return
      }
      if (!this.copyData.sourceMaterialId) { this.$message.warning('请选择源物料'); return }
      const run = () => {
        request.post('/base/material/copyData', {
          targetMaterialId: this.copyData.targetMaterialId,
          sourceMaterialId: this.copyData.sourceMaterialId,
          copyUnit: this.copyData.copyUnit ? '1' : '0',
          copyAttribute: this.copyData.copyAttribute ? '1' : '0',
          copyBom: this.copyData.copyBom ? '1' : '0',
          onlyEnabledBom: this.copyData.onlyEnabledBom ? '1' : '0'
        }).then(res => {
          const body = res.data || {}
          const bomRange = this.copyData.copyBom ? (this.copyData.onlyEnabledBom ? '（仅启用版本）' : '（全部版本）') : ''
          this.$message.success(`复制成功：单位换算${body.unitCount || 0}条，物料属性${body.attributeCount || 0}条，BOM${body.bomCount || 0}条${bomRange}`)
          this.copyDataVisible = false
          this.open(this.copyData.targetMaterialId, true)
          this.load()
        }).catch(() => {})
      }
      if (this.copyData.copyBom && this.copyData.targetBomCount > 0) {
        this.$confirm('目标物料已存在BOM，复制后将覆盖原BOM数据，是否继续？', '提示', { confirmButtonText: '继续复制', cancelButtonText: '取消', type: 'warning' }).then(run).catch(() => {})
        return
      }
      if (this.copyData.copyBom && this.copyData.sourceBomCount === 0) {
        this.$confirm('当前条件下源物料没有可复制的BOM数据，是否继续复制其它数据？', '提示', { confirmButtonText: '继续复制', cancelButtonText: '取消', type: 'warning' }).then(run).catch(() => {})
        return
      }
      run()
    },
    remove() {
      this.$confirm('确定删除该物料?', '提示', { type: 'warning' }).then(() => {
        request.post('/base/material/delete', { materialId: this.form.materialId }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    openClassify(row, parentId) {
      if (row) {
        this.classify = { ...row, parentId: row.parentId || null, sort: row.sort == null ? 0 : Number(row.sort) }
      } else {
        const parent = parentId || this.currentClassify || null
        this.classify = { classifyCode: '', classifyName: '', parentId: parent || null, sort: 0 }
      }
      this.classifyVisible = true
    },
    saveClassify() {
      if (!this.classify.classifyCode) { this.$message.warning('请填写分类编码'); return }
      if (!this.classify.classifyName) { this.$message.warning('请填写分类名称'); return }
      const payload = { ...this.classify, parentId: this.classify.parentId || '' }
      request.post('/base/materialClassify/' + (this.classify.classifyId ? 'update' : 'save'), payload).then(() => {
        this.$message.success('分类已保存'); this.classifyVisible = false; this.loadClassifies()
      }).catch(() => {})
    },
    removeClassify(row) {
      const data = row && row.classifyId ? row : this.classify
      if (!data || !data.classifyId) return
      this.$confirm('确认删除分类「' + data.classifyName + '」？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/materialClassify/delete', { classifyId: data.classifyId }).then(() => {
          this.$message.success('已删除')
          this.classifyVisible = false
          if (this.currentClassify === data.classifyId) this.currentClassify = ''
          this.loadClassifies()
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.split { display: flex; gap: 12px; align-items: stretch; min-height: calc(100vh - 120px); }
.cat-panel { width: 200px; flex-shrink: 0; border: 1px solid #e2e8f0; border-radius: 8px; background: #fff; display: flex; flex-direction: column; min-height: 420px; overflow: hidden; }
.cat-hd { display: flex; align-items: center; justify-content: space-between; padding: 10px 12px; border-bottom: 1px solid #e2e8f0; font-weight: 600; color: #0f172a; font-size: 13px; }
.cat-hd-actions .el-button { padding: 0 4px; }
.cat-all { padding: 8px 12px; font-size: 13px; color: #334155; cursor: pointer; border-bottom: 1px solid #f1f5f9; }
.cat-all:hover, .cat-all.active { background: #eff6ff; color: #1d4ed8; }
.cat-tree { flex: 1; overflow: auto; padding: 8px 4px 12px; background: transparent; }
.cat-tree >>> .el-tree-node__content { height: 32px; }
.cat-node { flex: 1; display: flex; align-items: center; justify-content: space-between; gap: 6px; padding-right: 4px; min-width: 0; }
.cat-label { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 13px; }
.cat-ops { display: none; gap: 6px; color: #94a3b8; flex-shrink: 0; }
.cat-ops i { cursor: pointer; font-size: 13px; }
.cat-ops i:hover { color: #1d4ed8; }
.cat-ops .el-icon-delete:hover { color: #ef4444; }
.cat-node:hover .cat-ops { display: inline-flex; }
.main { flex: 1; min-width: 0; }
.list-pagination { margin-top: 10px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #409eff; cursor: pointer; }
.mat-dialog-title { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.mat-dialog-actions .el-button { margin-left: 8px; }
.copy-tip { color: #909399; font-size: 12px; margin-top: 4px; }
.query-summary { color: #909399; }
.attr-value-row { display: flex; align-items: center; margin-bottom: 4px; }
</style>
